import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

@inject('store')
@observer
class Left extends Component {
    render() {
        const { data } = this.props.store.general;
        const Amount_occupancy = Object.entries(data.Amount_occupancy || {}).map(x => x[1]);
        const totalNum = Amount_occupancy.reduce((a, b) => (a + Number(b)), 0).toFixed(0);
        const monthNum = Amount_occupancy.reduce((a, b) => a <= Number(b) ? Number(b) : a, 0).toFixed(0);

        return (
            <div className="content">
                <div className="title">占用房数 Occupied Rooms {totalNum}</div>
                {/* <div className="text">{totalNum}</div> */}
                <div id="BI_title_left" style={{ height: 160, width: "100%" }}> </div>
                <div className="foot">最高占用房数 Highest：{monthNum}</div>
            </div>
        );
    }
}

export default Left;


// WEBPACK FOOTER //
// ./src/components/BI/home/title/Left.js